import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserContext } from '~/components/providers/UserProvider';

import { getAutoPickStrategy } from '~/services/contests/contests.service.api';

export const useAutoPickStrategy = (contestId: string, enabled = true) => {
  const { user } = useContext(UserContext);

  // eslint-disable-next-line local-rules/require-query-stale-time
  return useQuery({
    queryKey: ['auto-pick-strategy', contestId],
    queryFn: () => getAutoPickStrategy(contestId),
    enabled: enabled && !!contestId && !!user?.id,
  });
};
